import styled from "styled-components";
import { bannerCarneSecaDegrad } from "../../assets/images";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #fff4e8;
`;

// CSS Banner
export const BannerWrapper = styled.div`
  background-image: url(${bannerCarneSecaDegrad});
  display: flex;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 442px;
  width: 100%;
  padding: 1% 10%;

  @media (max-width: 700px) {
    min-height: 300px;
  }

  @media (max-width: 350px) {
    min-height: 250px;
  }

  @media (max-width: 600px) {
    padding: 1% 5%;
  }
`;

export const Banner = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  width: 100%;
  min-height: 300px;
  object-fit: cover;
`;

export const BannerText = styled.h1`
  display: flex;
  position: relative;
  font-family: "Passion One", cursive;
  color: white;
  font-size: 4rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  padding: 1% 10%;
  margin-top: 130px;

  @media (max-width: 700px) {
    font-size: 2.5rem;
    margin-top: 100px;
  }

  @media (max-width: 350px) {
    font-size: 1.8rem;
    margin-top: 80px;
  }

  @media (max-width: 600px) {
    padding: 1% 5%;
  }
`;

// CSS Informações
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1% 10%;

  @media (max-width: 600px) {
    padding: 1% 5%;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  width: 100%;
  padding: 20px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const InfoCard = styled.div``;

export const InfoTitle = styled.h2`
  font-size: 2rem;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  line-height: 90%;
  latter-spacing: 0;
  margin-bottom: 10px;
  color: #560000;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

export const InfoText = styled.p`
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.5;
  color: #606060;
  position: relative;
  padding-left: 1.5em;

  &::before {
    content: "•";
    position: absolute;
    left: 0;
    top: -15px;
    font-size: 2rem;
    line-height: 1.5;
    color: #606060;
  }

  @media (max-width: 600px) {
    font-size: 0.8rem;
  }
`;

// Meus Produtos
export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 620px;
  background: linear-gradient(180deg, #881c15 0%, #570b06 100%);

  @media (max-width: 900px) {
    height: 520px;
  }

  @media (max-width: 600px) {
    height: 500px;
  }
`;

export const ProductsTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 900;
  color: #ffe1bc;
  padding: 60px 120px;
  font-family: "Montserrat", sans-serif;
  line-height: 111.00000000000001%;
  letter-spacing: 0;
  margin: 0;
  color: #ffe1bc;

  @media (max-width: 1400px) {
    padding: 50px 90px;
  }

  @media (max-width: 900px) {
    font-size: 2.2rem;
    padding: 30px 60px;
  }

  @media (max-width: 600px) {
    font-size: 1.7rem;
    padding: 20px 20px;
  }
`;

// CSS Contatos e Selos
export const ContatosESelosContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  width: 100%;

  padding: 20px 0;
`;

export const BoxTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 75%;
  background-color: #292929;
  padding: 30px 40px;
  border-radius: 10px;
  margin-top: -80px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 20px;
    padding: 20px 20px;
    margin-top: -90px;
  }

  @media (max-width: 410px) {
    gap: 10px;
    padding: 10px 10px;
    margin-top: -75px;
  }

  h2 {
    font-size: 2rem;
    font-weight: 900;
    color: #ffffff;
    font-family: "Montserrat", sans-serif;
    line-height: 90%;
    letter-spacing: 0;
    margin: 0;
    margin-bottom: 10px;

    @media (max-width: 900px) {
      font-size: 1.5rem;
    }

    @media (max-width: 600px) {
      text-align: center;
    }

    @media (max-width: 410px) {
      font-size: 1.2rem;
    }

    @media (max-width: 330px) {
      font-size: 1rem;
    }
  }

  p {
    font-size: 1rem;
    color: #ff0000;
    letter-spacing: 0;
    line-height: 108%;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    margin: 0;

    @media (max-width: 900px) {
      font-size: 0.8rem;
    }

    @media (max-width: 600px) {
      text-align: center;
    }

    @media (max-width: 410px) {
      font-size: 0.7rem;
    }
  }
`;

export const ButtonContatos = styled.button`
  background-color: #ffe1bc;
  color: #881c15;
  font-size: 1rem;
  font-weight: 600;
  line-height: 108%;
  letter-spacing: 0;
  font-family: "Montserrat", sans-serif;
  horizontal-align: center;
  vertical-align: middle;
  padding: 10px 80px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ffce93;
  }

  @media (max-width: 900px) {
    padding: 10px 20px;
  }

  @media (max-width: 410px) {
    padding: 8px 15px;
  }
`;

export const BoxImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  justify-content: left;
  align-items: center;
  margin-top: 20px;
  margin-left: 20%;

  @media (max-width: 600px) {
    margin-left: 0;
    justify-content: center;
    gap: 10px;
  }
`;

export const BoxImageSisbi = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  max-width: 110px;

  @media (max-width: 600px) {
    max-width: 80px;
  }

  @media (max-width: 410px) {
    max-width: 70px;
  }
`;

export const BoxImageMaisIntegridade = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  max-width: 78px;

  @media (max-width: 600px) {
    max-width: 60px;
  }

  @media (max-width: 410px) {
    max-width: 50px;
  }
`;

export const BoxImageMapa = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  max-width: 128px;

  @media (max-width: 600px) {
    max-width: 100px;
  }

  @media (max-width: 410px) {
    max-width: 80px;
  }
`;

export const SobreContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: linear-gradient(90deg, #ffe1bc 0%, #fff7ee 100%);
  gap: 10%;
  padding: 5% 10%;

  @media (max-width: 1200px) {
    gap: 5%;
    padding: 5% 7%;
  }

  @media (max-width: 1000px) {
    padding: 5% 3%;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    padding: 5% 10%;
    gap: 20px;
  }

  @media (max-width: 600px) {
    padding: 5% 5%;
  }
`;

export const DivAlertInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  img {
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;

export const DivAlertInfoP = styled.p`
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 108%;
  vertical-align: middle;
  color: #000000;
`;

export const DivAlertInfo2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h2 {
    font-size: 1.2rem;
    font-weight: 700;
    color: #881c15;
    font-family: "Montserrat", sans-serif;
    line-height: 23px;
    letter-spacing: 0;
    vertical-align: middle;
    color: #000000;
    margin: 0;
    margin-bottom: 20px;
    padding: 0;
  }

  p {
    font-size: 1rem;
    color: #000000;
    letter-spacing: 0;
    line-height: 108%;
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    padding: 0;
    margin: 0;
  }

  @media (max-width: 900px) {
    display: none !important;
  }
`;

export const DivAlertInfo3 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  img {
    max-width: 150px;
    margin-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
  }

  h2 {
    font-size: 1rem;
    font-weight: 700;
    color: #560000;
    font-family: "Montserrat", sans-serif;
    line-height: 23px;
    letter-spacing: 0;
    vertical-align: middle;
    margin: 0;
    padding: 0;
  }

  p {
    font-size: 1rem;
    color: #560000;
    letter-spacing: 0;
    line-height: 108%;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10%;
  background: #222222;

  color: #fff;
  gap: 20px;

  p {
    font-size: 1rem;
    color: #fff;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    line-height: 108%;
    letter-spacing: 0;
    margin: 0;
    text-align: center;

    @media (max-width: 900px) {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    padding: 20px 5%;
  }
`;
